import React from "react";
import ProcessingOfSoldProducts from "./ProcessingOfSoldProducts";
import MainDashboardLayout from "../../../Layout/MainDashboardLayout";
import Scope3Layout from "../../../Layout/Scope3Layout";
import Unauthorized from "../../../Components/Unauthorized/Unauthorized";
import { useUser } from "../../../context/AuthContext";
import GroupAdminSidebar from "../../../Layout/GroupAdminSidebar";

const ProcessingOfSoldProductsPage = () => {
  const { user } = useUser();

  return (
    <MainDashboardLayout
      sidebar={user?.groupManager ? <GroupAdminSidebar /> : <Scope3Layout />}
    >
      <Unauthorized requiredModule="Environment | Scope 3 | Processing of Sold Products">
        <ProcessingOfSoldProducts />
      </Unauthorized>
    </MainDashboardLayout>
  );
};

export default ProcessingOfSoldProductsPage;
